import { render } from "./IDRJobStackDeploymentsDetail.vue?vue&type=template&id=48ff6c53&scoped=true"
import script from "./IDRJobStackDeploymentsDetail.vue?vue&type=script&lang=js"
export * from "./IDRJobStackDeploymentsDetail.vue?vue&type=script&lang=js"

import "./IDRJobStackDeploymentsDetail.vue?vue&type=style&index=0&id=48ff6c53&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ff6c53"]])

export default __exports__